import * as SentryOriginal from '@sentry/react';

const captureError = (error, context = {}) => {

  SentryOriginal.withScope((scope) => {
    if (context?.cause) {
      scope.setFingerprint([context.cause]);
    }
    // Улучшение группировки
    if (error instanceof TypeError) {
      scope.setFingerprint(['type-error', error.message]);
    } else if (error.message.includes('Network Error')) {
      scope.setFingerprint(['network-error']);
    }

    // Добавление контекста
    scope.setContext('custom_context', {
      ...context,
      userAgent: navigator.userAgent,
    });
    console.log('[SENTRY] captureError', {
      cause: context?.cause,
      fingerprint: [context?.cause],
      error,
      context,
      custom_context: {
        ...context,
        userAgent: navigator.userAgent,
      },
    });

    SentryOriginal.captureException(error);
  });
};

export default captureError;
